// CalendarEventForm.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from './config';
import { Box, Paper, TextField, Button, Stack } from '@mui/material';

export default function CalendarEventForm() {
  const [isAuthed, setIsAuthed] = useState(false);
  const [form, setForm] = useState({
    summary: '',
    description: '',
    startDateTime: '',
    endDateTime: '',
    attendees: '',
  });
  const [result, setResult] = useState(null);

  useEffect(() => {
    // OPTIONAL: check auth status if you’ve implemented /calendar/auth-status
    axios
      .get(`${config.API_BASE_URL}/calendar/auth-status`)
      .then(res => setIsAuthed(res.data.authed))
      .catch(() => setIsAuthed(false));
  }, []);

  const handleConnect = async () => {
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/calendar/auth`,
        { params: { userId: localStorage.getItem('userId') } }
      );
      window.location.href = res.data.authUrl;
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      summary: form.summary,
      description: form.description,
      startDateTime: new Date(form.startDateTime).toISOString(),
      endDateTime:   new Date(form.endDateTime).toISOString(),
      attendees: form.attendees
        .split(',')
        .map(email => email.trim())
        .filter(Boolean),
    };

    try {
      const res = await axios.post(
        `${config.API_BASE_URL}/calendar/events`,
        payload
      );
      setResult({ success: true, link: res.data.link });
    } catch (err) {
        const raw = err.response?.data?.error;
        const message =
        typeof raw === 'string'
           ? raw
          : Array.isArray(raw?.errors)
             ? raw.errors.map(e => e.message).join('; ')
             : err.message;
        setResult({ success: false, error: message });
    }
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Paper elevation={3} sx={{ p: 3, width: '100%', maxWidth: 400 }}>
        {!isAuthed ? (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleConnect}
          >
            Connect Google Calendar
          </Button>
        ) : (
          <Stack
            component="form"
            onSubmit={handleSubmit}
            spacing={2}
          >
            <TextField
              label="Title"
              name="summary"
              value={form.summary}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Description"
              name="description"
              value={form.description}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Start Date & Time"
              name="startDateTime"
              type="datetime-local"
              value={form.startDateTime}
              onChange={handleChange}
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="End Date & Time"
              name="endDateTime"
              type="datetime-local"
              value={form.endDateTime}
              onChange={handleChange}
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Attendees (comma-separated)"
              name="attendees"
              value={form.attendees}
              onChange={handleChange}
              fullWidth
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
            >
              Create Event
            </Button>
          </Stack>
        )}

        {result && (
          <div style={{ marginTop: '1.5rem' }}>
            {result.success ? (
              <p>
                ✅ Event created!{' '}
                <a href={result.link} target="_blank" rel="noopener noreferrer">
                  View in Calendar
                </a>
              </p>
            ) : (
              <p>❌ Error: {result.error}</p>
            )}
          </div>
        )}
      </Paper>
    </Box>
  );
}
